import { formatDateWithFormatter } from '@/utils/function'
import { paths } from '@/utils/path'
import { useTranslation } from 'react-i18next'
import { generatePath, Link } from 'react-router-dom'
import { ContractServicesSectionProps } from './types'

const ContractServicesSection = ({
    contractServices,
}: ContractServicesSectionProps) => {
    const { t } = useTranslation()

    if (contractServices.length === 0) return null

    return (
        <div className="p-2 border-t border-gray-100 space-y-2">
            <div className="text-[10px] font-medium text-purple-700 uppercase">
                {t('services')} ({contractServices.length})
            </div>
            {contractServices.map((note) => (
                <Link
                    key={note.service?.service_id}
                    to={generatePath(paths.serviceDetail, {
                        id: note.service?.service_id?.toString() || '',
                    })}
                    target="_blank"
                    className="block p-2 bg-purple-50 rounded border border-purple-100 hover:border-purple-300 hover:bg-purple-100/50 transition-colors"
                >
                    <div className="flex items-center justify-between gap-2 mb-1">
                        <span className="text-xs font-medium text-purple-700 hover:underline">
                            #{note.service?.service_id} -{' '}
                            {note.service?.service_name}
                        </span>
                        <span
                            className={`text-[10px] px-1.5 py-0.5 rounded font-medium ${
                                note.service?.service_status === 'active'
                                    ? 'bg-emerald-100 text-emerald-600'
                                    : note.service?.service_status ===
                                        'waiting-confirm'
                                      ? 'bg-blue-100 text-blue-600'
                                      : note.service?.service_status ===
                                              'cancelled' ||
                                          note.service?.service_status ===
                                              'rejected'
                                        ? 'bg-red-100 text-red-600'
                                        : 'bg-gray-100 text-gray-600'
                            }`}
                        >
                            {t(`service.${note.service?.service_status}`)}
                        </span>
                    </div>
                    <div className="text-[10px] text-gray-600 truncate mb-1">
                        {note.service?.product_group_name}
                    </div>
                    <div className="flex items-center gap-2 text-[10px] text-purple-600">
                        {note.service?.service_type && (
                            <span className="px-1.5 py-0.5 rounded bg-purple-100 text-purple-600">
                                {t(`service.${note.service.service_type}`)}
                            </span>
                        )}
                        {note.service?.service_start_date && (
                            <span>
                                {formatDateWithFormatter(
                                    note.service.service_start_date,
                                    'DD/MM/YYYY'
                                )}
                            </span>
                        )}
                    </div>
                </Link>
            ))}
        </div>
    )
}

export default ContractServicesSection
